//// Country Dropdown Js ////
function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('genital-herpes_lastQuestionafter', newValue);
}
function numberChange(lastNumber) {
    setCookie('genital-herpes_lastNumber', lastNumber);
}


function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}

$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});

$.getJSON('https://cdn.shopify.com/s/files/1/0425/4197/3660/files/custom-countries.json?v=1784870873', function(data) {
    $(".country_list").empty();
    data.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    $.each(data, function(index, item) {
        var html = `
            <div class="country_select_option">
                <div class="country_select_bg">
                    <div class="country_select_wrapper">
                        <span><img src="${item.flag}" alt="${item.name}" style="max-width:28px;"><div class="country_text">${item.name}</div></span>
                        <div class="select_contentText"><div class="country_code">${item.code}</div></div>
                    </div>
                </div>
            </div>
        `;
        $(".country_list").append(html);
    });
    $('.country_select_option').on("click", function () {
        var image = $(this).find("img").attr("src");
        var code = $(this).find(".country_code").text();
        var country = $(this).find(".country_text").text();
        $(".distribute .trigger-icon-button__StrokeIcon img").attr("src", image);
        $(".country_dropdown").removeClass("select_dropdown_show");
        $(".select_country_box input").attr("data-contry-code", code);
        $("#checkNumber").attr("data-contry-code", code);
        $(".form-selected-answer [data-handle='country-code']").val(code);
        $(".selected-country-name").text(country);
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-question').each(function() {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
});

$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
// $('.form-selected-answer [data-handle="what-other-forms-of-id-do-you-have"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();
// $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').remove();
$('.form-selected-answer [data-handle="we-require-a-full-body-shot-photo-of-you-either-standing-in-front-of-a-mirror-or-taken-by-someone-else-your-face-does-not-need-to-be-in-the-photo"]').remove();


$('.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    var cookieToDelete = 'genital-herpes';
    deleteCookie(cookieToDelete);
    deleteCookie("genital-herpes_lastQuestionafter");
    $('.form-selected-answer input[type="hidden"]').each(function(){
      $(this).val("");
    })
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('genital-herpes_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('genital-herpes_lastNumber');
  
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
          $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
});

var que1 = "has-a-doctor-previously-diagnosed-you-with-genital-herpes-herpes-sim-plex-virus",
    que2 = "do-you-know-what-type-of-hsv-you-have",
    que3 = "are-you-having-an-out-break-at-the-moment",
    que4 = "how-often-do-you-have-outbreaks-in-12-months-period",
    que5 = "please-provide-your-sex-at-birth",
    que6 = "have-you-used-antiviral-medication-before-to-manage-outbreaks",
    que7 = "what-medications-have-you-used-before-to-manage-outbreaks",
    que8 = "did-you-have-a-good-result-from-treatment",
    que9 = "did-you-experience-any-side-effects",
    que10 = "what-side-effects-did-you-experience",
    que11 = "are-you-currently-taking-any-medication",
    que12 = "what-medication-are-you-currently-taking",
    que13 = "do-you-have-any-allergies",
    que14 = "what-allergies-do-you-have",
    que15 = "do-you-have-any-medical-conditions-or-a-history-of-prior-surgeries",
    que16 = "what-are-your-medical-conditions-and-history-of-prior-surgeries",
    que17 = "is-there-anything-else-you-want-your-doctor-to-know-about-your-condition-or-health",
    que18 = "what-would-you-like-to-tell-your-doctor",
    que19 = "is-there-any-chance-that-you-are-pregnant",
    que20 = "would-you-like-to-have-the-medication-for-treatment-of-your-current-symptoms-or-for-prevention-of-future-flare-up",
    que21 = "can-you-confirm-that-the-information-you-have-given-is-true-and-accurate-that-this-medication-is-solely-for-yourself-and-that-if-prescribed-the-medication-you-will-review-the-information-supplied-regarding-the-medication-and-side-effects",
    que22 = "please-enter-your-date-of-birth",
    que23 = "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id",
    que24 = "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment";

// new Question add 25 Jul =====
var que25 = "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead";
var que26 = "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues";
var que27 = "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues";


$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var weightLossCookieValue = getCookie('genital-herpes');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
      for (var i = 0; i < weightLossObjectItem.length; i++) {
      var currentObject = weightLossObjectItem[i];
      for (var key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          var cookieValue = currentObject[key];
          if(key == selfHandle){
            $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
          }else{
            if($('#callback-form input[data-handle="'+key+'"]').length == 0){
              var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
              var getQuestion = getName;
              $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
              $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
            }
          }
        }
      }
    }
    
    if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'No'){
        if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
        }
     }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'Yes'){
       if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
          var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
          $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
       }
     }
    
  }
});



$('.form_loop[data-question=' + que25 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que25 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
            pushHistory($currentNumber + 1);
            CalculateP();
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="please-provide-your-sex-at-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $('.form_loop[data-question="please-provide-your-sex-at-birth"]').data("question");
          }
          
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});

$('.form_loop[data-question=' + que26 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que26 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});

$('.form_loop[data-question=' + que27 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + que27 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
        
          pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });







//  STEP 1
$('.form_loop[data-question=' + que1 + '] .form_action_btn, .form_loop[data-question=' + que1 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
           var newValue = { 'has-a-doctor-previously-diagnosed-you-with-genital-herpes-herpes-sim-plex-virus': $value };
           if ($this.val() == 'Yes') {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1); 
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
           }else{
             $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
             $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
           }
            $(`.form-selected-answer [data-handle=${que1}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

//  STEP 2
$('.form_loop[data-question=' + que2 + '] .form_action_btn, .form_loop[data-question=' + que2 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que2}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'do-you-know-what-type-of-hsv-you-have': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 3
$('.form_loop[data-question=' + que3 + '] .form_action_btn, .form_loop[data-question=' + que3 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que3}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'are-you-having-an-out-break-at-the-moment': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 4
$('.form_loop[data-question=' + que4 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que4 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'how-often-do-you-have-outbreaks-in-12-months-period': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 5 || Is First Questions
$('.form_loop[data-question=' + que5 + '] .form_action_btn, .form_loop[data-question=' + que5 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que5}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-provide-your-sex-at-birth': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 6
$('.form_loop[data-question=' + que6 + '] .form_action_btn, .form_loop[data-question=' + que6 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'have-you-used-antiviral-medication-before-to-manage-outbreaks': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${que6}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.form_loop[data-question=' + que11 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                $(`.form-selected-answer [data-handle=${que6}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $('.form_loop[data-question=' + que11 + ']').data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 7
$('.form_loop[data-question=' + que7 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que7 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-medications-have-you-used-before-to-manage-outbreaks': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 8
$('.form_loop[data-question=' + que8 + '] .form_action_btn, .form_loop[data-question=' + que8 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que8}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'did-you-have-a-good-result-from-treatment': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 9
$('.form_loop[data-question=' + que9 + '] .form_action_btn, .form_loop[data-question=' + que9 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'did-you-experience-any-side-effects': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${que9}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.form_loop[data-question=' + que11 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                $(`.form-selected-answer [data-handle=${que9}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $('.form_loop[data-question=' + que11 + ']').data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 10
$('.form_loop[data-question=' + que10 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que10 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-side-effects-did-you-experience': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 11
$('.form_loop[data-question=' + que11 + '] .form_action_btn, .form_loop[data-question=' + que11 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'are-you-currently-taking-any-medication': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${que11}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.form_loop[data-question=' + que13 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                $(`.form-selected-answer [data-handle=${que11}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $('.form_loop[data-question=' + que13 + ']').data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 12
$('.form_loop[data-question=' + que12 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que12 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-medication-are-you-currently-taking': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 13
$('.form_loop[data-question=' + que13 + '] .form_action_btn, .form_loop[data-question=' + que13 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'do-you-have-any-allergies': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.form_loop[data-question=' + que15 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                var afterlastQuestion = $('.form_loop[data-question=' + que15 + ']').data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            $(`.form-selected-answer [data-handle=${que13}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 14
$('.form_loop[data-question=' + que14 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que14 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-allergies-do-you-have': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 15
$('.form_loop[data-question=' + que15 + '] .form_action_btn, .form_loop[data-question=' + que15 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'do-you-have-any-medical-conditions-or-a-history-of-prior-surgeries': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.form_loop[data-question=' + que17 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                var afterlastQuestion = $('.form_loop[data-question=' + que17 + ']').next().data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            $(`.form-selected-answer [data-handle=${que15}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 16
$('.form_loop[data-question=' + que16 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que16 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-are-your-medical-conditions-and-history-of-prior-surgeries': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 17
$('.form_loop[data-question=' + que17 + '] .form_action_btn, .form_loop[data-question=' + que17 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'is-there-anything-else-you-want-your-doctor-to-know-about-your-condition-or-health': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            } else {
                if ($('#callback-form input[data-handle=please-provide-your-sex-at-birth]').val() == 'Male') {
                    $parent.removeClass('d-block').addClass('d-none');
                    $('.form_loop[data-question=' + que20 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                    var afterlastQuestion = $('.form_loop[data-question=' + que20 + ']').data("question");
                } else {
                    $parent.removeClass('d-block').addClass('d-none');
                    $('.form_loop[data-question=' + que19 + ']').addClass('d-block').find('.number').html($currentNumber + 1)
                    var afterlastQuestion = $('.form_loop[data-question=' + que19 + ']').data("question");
                }
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            $(`.form-selected-answer [data-handle=${que17}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 18
$('.form_loop[data-question=' + que18 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que18 + ']').val($value);
        var newValue = { 'what-would-you-like-to-tell-your-doctor': $value };
        setTimeout(function() {
            if ($('#callback-form input[data-handle=please-provide-your-sex-at-birth]').val() == 'Male') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 19
$('.form_loop[data-question=' + que19 + '] .form_action_btn, .form_loop[data-question=' + que19 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que19}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'is-there-any-chance-that-you-are-pregnant': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 20
$('.form_loop[data-question=' + que20 + '] .form_action_btn, .form_loop[data-question=' + que20 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $(`.form-selected-answer [data-handle=${que20}]`).val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'would-you-like-to-have-the-medication-for-treatment-of-your-current-symptoms-or-for-prevention-of-future-flare-up': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 21
$('.form_loop[data-question=' + que21 + '] .form_action_btn, .form_loop[data-question=' + que21 + '] input[type=checkbox]').click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var newValue = { 'can-you-confirm-that-the-information-you-have-given-is-true-and-accurate-that-this-medication-is-solely-for-yourself-and-that-if-prescribed-the-medication-you-will-review-the-information-supplied-regarding-the-medication-and-side-effects': $value };
            if ($value == 'Yes' || $value == 'yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${que21}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $parent.removeClass('d-block').addClass('d-none');
                $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                $(`.form-selected-answer [data-handle=${que21}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
            }
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP 22
$('.form_loop[data-question=' + que22 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val();
    var InputDate = new Date($MM + '/' + $DD + '/' + $YY);
    var Today = new Date();
    var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());

    var Difference_In_Time = Today.getTime() - InputDate.getTime();

    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    if (Difference_In_Days >= 18 && ($MM.length <= 2 && $DD.length <= 2 && $YY.length == 4)) {

      if ($('.form-selected-answer [data-handle=' + que25 + ']').val() == 'Yes') {
        $(this).parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').data("question");
      } else {
        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
      }
      
        pushHistory($currentNumber + 1);
        $('.form-selected-answer [data-handle=' + que22 + ']').val($DD + '/' + $MM + '/' + $YY);
        CalculateP();
        var newValue = { 'please-enter-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
        pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 23
$('.form_loop[data-question=' + que23 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que23 + ']').val($value);
        setTimeout(function() {

          if ($('.form-selected-answer [data-handle=' + que25 + ']').val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="please-enter-your-date-of-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="please-enter-your-date-of-birth"]').data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }

          
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 24
$('.form_loop[data-question=' + que24 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    if ($parent.find('.select_country_box input').val().length > 9) {
        $this.attr('disabled', 'disabled');
        var Value = $parent.find('.select_country_box input').val(),
            Ccode = $parent.find('.select_country_box input').data('contry-code');

        $('.form-selected-answer [data-handle=country-code]').val(Ccode);
        $('#checkNumber').val(Value);
        $('#confirmation_popup').toggle();
        CalculateP();
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }

});
function otpAfterClick() {
$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   var $currentNumber = parseInt($('.form_loop[data-question=' + que24 + ']').find('.number').html());
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();
    $('.form-selected-answer [data-handle=' + que24 + ']').val(checkVal);
    $('.form_loop[data-question=' + que24 + '] button').find('input').val(checkVal);
    var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': checkVal };
    var afterlastQuestion =  $('.form_loop[data-question=' + que24 + '] button').parents('.form_loop').next().data("question");
    pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
    $('.form_loop[data-question=' + que24 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1)
   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})
}
otpAfterClick()


// STEP ?
$('.form_loop[data-question="do-you-have-a-medicare-card"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            var newValue = { 'do-you-have-a-medicare-card': $value };
            if ($value == "yes" || $value == "Yes") {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);

                var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
                    cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
                    monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';

                $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
                $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
                var afterlastQuestion = $parent.next().data("question");

            } else {
                $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
                $parent.addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().next().data("question");
            }
            pushValueToCookieArray('genital-herpes', newValue, afterlastQuestion, $currentNumber + 1); 
            $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP ??
$('.form_loop[data-question="please-enter-your-medicare-card-details"] .form_submit_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop');

    var $MM = $('.card_years_field .month input').val(),
        $YY = $('.card_years_field .year input').val(),
        $INR = $parent.find('.details_filed input.enter_irn_number').val(),
        $CardNumber = $parent.find('.details_filed input.enter_card_number').val();

    if ($parent.find('.details_filed input.enter_irn_number').val().length == 1 && $parent.find('.details_filed input.enter_card_number').val().length == 10 && $MM <= 12 && $MM != '' && $YY != '') {
        $parent.addClass('d-none').removeClass('d-block');
        $('.neurological_que[data-question="appoinment"]').addClass('d-block');
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_irn"]').val($INR);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_number"]').val($CardNumber);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_month_year"]').val(`${$MM}/${$YY}`);
        CalculateP();
        $('#callback-form').submit();
    } else {
        shakeEffect($parent);
        // errorPopUp();
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP ???
$('.form_loop[data-question="what-is-your-ihi"] .form_submit_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $value = $parent.find('.details_filed input').val();
    if ($value != '') {
        $parent.addClass('d-none').removeClass('d-block');
        CalculateP();
        $('.form-selected-answer [data-handle="what-is-your-ihi"]').val($value);
        $('#callback-form').submit();
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});




var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', { eventCategory: 'genital-herpes', eventAction: 'Submit', eventLabel: 'Genital herpes form', eventValue: 1 });


    $Form.find("input[type='hidden']").each(function() {
      var get_data_handle = $(this).attr('data-handle');
  
      if(get_data_handle=='please-enter-your-medicare-card-details'){
          if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
            if($(this).val() == ""){
              $(this).remove();
            }    
          }
      }else{
        if($(this).val() == ""){
          $(this).remove();
        }
      }
      
    })

    var noscriptContent = $('#productString_url').html();
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urls = noscriptContent.match(urlRegex);

    var redirectionMainUrl = 'https://bursthealth.com.au/products/genital-herpes';
    
    $('.form-selected-answer').append(`<input type="hidden" name="Product redirection Url" value="${redirectionMainUrl}">`);
    $('.form-selected-answer').append(`<input type="hidden" name="Product Session id" value="${unique_id}">`);
    $.each(urls, function(index, url) {
     if (url.includes(redirectionMainUrl) || redirectionMainUrl.includes(url)) {
      $('.form-selected-answer').append(`<input type="hidden" name="Product String Url" value="true">`);
     }
    });

  
    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);
            jQuery.post('/cart/update.js', "attributes[weightloss-uid]=" + data.unique_id);
            location.href = data.product_link;

            var cookieToDelete = 'genital-herpes';
            deleteCookie(cookieToDelete);
            deleteCookie("genital-herpes_lastQuestionafter");

        },
        error: function() {
            location.href = 'https://bursthealth.com.au/products/genital-herpes';
        }
    });
});


function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

function onmaxlength(e) {
    // var $this = $(e);
    // var maxlength = $this.attr('maxlength');
    // var value = $(e).val();
    // if (value && value.length >= maxlength) {
    //   return false;
    // }else{
    //   return true;
    // }
}